import PropTypes from 'prop-types';
import React from 'react';
import UserIcon from "../../../gd-ui/icon/user/user";

type Props = {
    className?  :   string
    disabled?   :   boolean
    size        :   number
    userId      :   ID
    palette?    :   string
    onDelete?   :   callback | null
    onClick?    :   callback | null
    value?      :   any
}

export default function PillUser(props: Props) {

    const onClick = (e:React.SyntheticEvent) => {

        // do not stop propagation yet !
        if (!props.onClick) return

        e.stopPropagation()
        // console.log("on click", props.value)
        if (props.onClick) props.onClick(props.value)
    }

    const onDelete = (e:React.SyntheticEvent) => {
        e.stopPropagation()
        // console.log("on delete", props.value)
        if (props.onDelete) props.onDelete(props.value)
    }


    const classes = Classes(
        'ui5-pill-u user', 'gray',
        's-'+props.size,
        props.className
    );

    let pillLabel, pillIcon

    switch (props.userId) {

        case '{assignedToUserId}':
            pillLabel   = 'Assigned to user'
            pillIcon    = <div className="icon ui5-ico-13 i5-user" />
            break

        case '{actionRequiredUserId}':
            pillLabel   = 'Action required user'
            pillIcon    = <div className="icon ui5-ico-13 i5-user" />
            break

        case '{currentUserId}':
            pillLabel   = 'Current user'
            pillIcon    = <div className="icon ui5-ico-13 i5-user" />
            break

        default:
            const user = gd.session.users.get(props.userId)
            pillLabel   = _.get(user,'name', false)
            pillIcon    = <UserIcon className="avatar" userId={props.userId} size="22"/>
            break
    }




    return (
        <div className={classes} onClick={onClick}>
            {pillIcon}
            <div className="pill-label">{pillLabel}</div>
            {props.onDelete &&  !props.disabled && <div className="i5-close" onClick={onDelete} />}
        </div>
    )
}


PillUser.propTypes = {
    className   : PropTypes.string,
    size        : PropTypes.oneOf([26, 22, '26','22']),

    palette     : PropTypes.oneOf(['transparent', 'gray']),
    color       : PropTypes.number,

    // label       : PropTypes.string,
    // icon        : PropTypes.string,

    // callbacks
    onClick     : PropTypes.func,
    onDelete    : PropTypes.func,       // if set adds delete button
    value       : PropTypes.any,       // this is what being passed when we set on click or on delete !!!

    classes     : PropTypes.any,
    style       : PropTypes.any,

    // Special cases
    userId      : PropTypes.string.isRequired,     // if passes - display icon & label automatically
}

PillUser.defaultProps = {
    size        : '26'
}
